/**
 * Shows a loading div.
 *
 * Props:
 * - text: Optional. Text to display (plain text only).
 * - style: Optional. One of the alert styles: success | info | warning | danger
 */

const Loading = ({ text, style }) => {
  return (
    <div className="container content">
      <div className={`alert alert-${style || 'info'}`}>
        <span className="fa fa-spinner fa-spin me-2" />
        {text || 'Loading...'}
      </div>
    </div>
  );
};

export default Loading;
